import styled, { css } from 'styled-components';

import { pxToRem } from 'utils/scss';

export const NumberBoxWrapper = styled.div`
  display: flex;
  flex-direction: ${props =>
    props.verticalAlign ? 'column-reverse' : 'column'};
  align-items: ${({ align }) => align};
  justify-content: ${({ justify }) => justify || 'center'};
  justify-content: center;
  position: relative;
  ${props =>
    props.centeredContent &&
    css`
      height: 100%;
    `}
`;
export const Number = styled.div`
  margin: ${pxToRem('8px')} 0;
  > span:nth-child(2) {
    margin-left: ${pxToRem('10px')};
  }

  ${props =>
    props.bulletStatus &&
    css`
      margin: ${pxToRem('8px')} ${pxToRem('15px')};
      position: relative;

      &::before {
        content: '';
        height: ${pxToRem('8px')};
        width: ${pxToRem('8px')};
        border-radius: 100%;
        background-color: ${props.theme.colors.semantic.secondary};
        top: 0.5rem;
        display: inline-block;
        margin-left: -${pxToRem('16px')};
        margin-right: ${pxToRem('8px')};
        position: absolute;
      }
    `}
  ${props =>
    props.verticalAlign &&
    css`
      margin-top: ${pxToRem('16px')};
      order: 1;
    `}
`;

export const NumberIcon = styled.div`
  position: ${props => props.position};
  top: ${props => (props.position === 'absolute' ? `${props.top}px` : 'unset')};
  right: ${props =>
    (props.position === 'absolute' ? `${props.right}px` : 'unset')};
  margin: ${props =>
    (props.position === 'absolute' ? 'unset' : `${props.iconMargin}`)};
  ${props =>
    props.centeredContent &&
    !props.verticalAlign &&
    css`
      display: flex;
      height: 100%;
      justify-content: center;
      align-items: center;
    `}
  ${props =>
    props.verticalAlign &&
    css`
      order: 2;
    `}
`;
